{
  "intent": "क्या आप अपनी {{property}} बेचना या किराए पर देना चाहते हैं?",
  "property_type": "यह किस प्रकार की संपत्ति है?",
  "location": "आपकी {{property}} कहाँ है? पिनकोड या पूरा पता सबसे अच्छा है। क्षेत्र/इलाका और शहर भी बता सकते हैं।",
  "location_city_in_state": "{{state}} में {{property}} किस शहर में है?",
  "location_locality": "{{city}} में कौन सा क्षेत्र या इलाका? पिनकोड हो तो बताएँ (जैसे सेक्टर 18, 110001)।",
  "location_pincode_us": "{{city}} में आपकी {{property}} का ZIP कोड क्या है?",
  "location_map_pin": "खरीदार आसानी से ढूंढ सकें, इसके लिए नीचे दिए गए मानचित्र पर अपनी {{property}} का सही स्थान पिन करें।",
  "location_full_address": "कृपया अपनी {{property}} के पते का पूरा विवरण (भवन का नाम, फ्लैट/यूनिट, सड़क, इलाका, पिनकोड) पुष्टि करें।",
  "bedrooms": "कितने बेडरूम (BHK) हैं?",
  "bathrooms": "कितने बाथरूम हैं?",
  "furnishing": "फर्निशिंग की स्थिति क्या है?",
  "facing": "{{property}} किस दिशा की ओर है?",
  "age_of_construction": "{{property}} का निर्माण कितना पुराना है?",
  "maintenance_charges": "इस {{property}} के लिए रखरखाव शुल्क क्या हैं? (यदि लागू न हो तो छोड़ सकते हैं)",
  "amenities": "उपलब्ध सुविधाओं का चयन करें:",
  "price": "अपेक्षित कीमत/किराया क्या है?",
  "parking_spaces": "कितने पार्किंग स्पॉट उपलब्ध हैं?",
  "nearby_places": "पास में कौन से स्थान हैं?",
  "connectivity": "कनेक्टिविटी कैसी है?",
  "floor_number": "{{property}} किस मंजिल पर है?",
  "area": "कुल क्षेत्रफल कितना है? (वैकल्पिक)",
  "area_type": "यह किस प्रकार का क्षेत्र है?",
  "lifts": "इमारत में कितने लिफ्ट उपलब्ध हैं?",
  "balconies": "{{property}} में कितने बालकनी हैं?",
  "title": "अपनी लिस्टिंग के लिए एक आकर्षक शीर्षक चुनें:",
  "images": "क्या आप {{property}} की कुछ तस्वीरें या वीडियो टूर अपलोड करना चाहेंगे?",
  "documents": "क्या आप कोई दस्तावेज़ अपलोड करना चाहेंगे? (ब्रोशर, फ्लोर प्लान, कानूनी दस्तावेज़, आदि)",
  "summary": "आपकी लिस्टिंग का सारांश दाईं ओर दिख रहा है। क्या सब कुछ सही है? हाँ टाइप करें या बदलाव के लिए नहीं।",
  "pg_name": "आपके PG / होस्टल का नाम क्या है?",
  "available_for": "यह PG किसके लिए उपलब्ध है?",
  "pg_present_in": "आपका PG स्वतंत्र बिल्डिंग, फ्लैट या सोसाइटी में कहाँ स्थित है?",
  "room_sharing": "रूम शेयरिंग के क्या विकल्प हैं? सभी लागू विकल्प चुनें।",
  "pg_sharing_details": "चयनित रूम शेयरिंग के लिए किराया विवरण दर्ज करें।",
  "pg_tenant_preference": "आप किस प्रकार के किराएदार पसंद करते हैं?",
  "pg_rules": "लागू PG नियम चुनें (या कोई न हो तो छोड़ें)।",
  "pg_gate_closing": "क्या सभी को गेट बंद होने से पहले PG में वापस आना होगा?",
  "pg_food": "क्या आपके PG में किराएदारों के लिए भोजन उपलब्ध है?",
  "pg_common_amenities": "आपके PG में कौन सी कॉमन एरिया सुविधाएं उपलब्ध हैं?",
  "pg_usp": "अपने PG के बारे में और बताएं — अद्वितीय बिक्री बिंदु (USP) जोड़ें।",
  "pg_room_facilities": "{{sharingLabel}} शेयरिंग रूम में कौन सी सुविधाएं उपलब्ध हैं?",
  "pg_available_from": "संपत्ति कब से उपलब्ध होगी?",
  "security_deposit": "सिक्योरिटी डिपॉजिट (INR) क्या है? यदि कोई नहीं है तो 0 लिखें।",
  "security_deposit_pg": "प्रति बिस्तर सिक्योरिटी डिपॉजिट (INR) क्या है? यदि कोई नहीं है तो 0 लिखें।",
  "commercial_subtype": "यह किस प्रकार की व्यावसायिक संपत्ति है?",
  "commercial_zone": "भूमि का ज़ोनिंग वर्गीकरण क्या है?",
  "total_floors": "इमारत में कुल कितनी मंजिलें हैं?",
  "personal_washroom": "क्या इसमें व्यक्तिगत वॉशरूम है?",
  "extra_pantry": "पैंट्री का प्रकार क्या है?",
  "furnishing_status": "फर्निशिंग की स्थिति क्या है?",
  "ideal_for_businesses": "यह स्थान किन व्यवसायों के लिए उपयुक्त है?",
  "washroom_available": "क्या वॉशरूम उपलब्ध है?",
  "corner_shop": "क्या यह कॉर्नर शॉप है?",
  "main_road_facing": "क्या यह मुख्य सड़क की ओर है?",
  "entrance_width": "प्रवेश द्वार की चौड़ाई (फीट) कितनी है?",
  "nearby_businesses": "आस-पास कौन से व्यवसाय हैं?",
  "floors_allowed_for_construction": "निर्माण के लिए कितनी मंजिलें अनुमत हैं?",
  "open_sides": "प्लॉट के कितने खुले किनारे हैं?",
  "road_width_facing_plot": "प्लॉट के सामने सड़क की चौड़ाई (फीट) कितनी है?",
  "boundary_wall": "क्या बाउंड्री वॉल है?",
  "corner_plot": "क्या यह कॉर्नर प्लॉट है?",
  "truck_accessibility": "क्या ट्रक पहुंच उपलब्ध है?",
  "loading_unloading_access": "क्या लोडिंग/अनलोडिंग की सुविधा है?",
  "road_width": "सड़क की चौड़ाई (फीट) कितनी है?",
  "ceiling_height": "छत की ऊंचाई (फीट) कितनी है?",
  "power_supply": "बिजली आपूर्ति का प्रकार क्या है?",
  "parking_space": "कितने पार्किंग स्थान उपलब्ध हैं?",
  "listing_subtype": "यह किस विशिष्ट प्रकार की है?",
  "possession_status": "कब्ज़े की स्थिति क्या है?",
  "available_from": "संपत्ति कब उपलब्ध होगी?",
  "currently_leased_out": "क्या संपत्ति वर्तमान में लीज़/किराए पर दी गई है?",
  "assured_returns": "क्या इस लिस्टिंग में सुनिश्चित रिटर्न हैं?",
  "booking_token_amount": "बुकिंग या टोकन राशि (INR में) कितनी है?",
  "maintenance_frequency": "रखरखाव शुल्क कितनी बार देय हैं?",
  "washroom_count": "कितने वॉशरूम हैं?",
  "plot_length": "प्लॉट की लंबाई (फीट में) कितनी है?",
  "plot_breadth": "प्लॉट की चौड़ाई (फीट में) कितनी है?",
  "_submit_ready": "बढ़िया! दाईं ओर 'Publish' बटन दबाएं अपनी लिस्टिंग सबमिट करने के लिए। 🎉",
  "_auto_publish": "बढ़िया! आपकी प्रॉपर्टी लिस्टिंग सबमिट की जा रही है... 🎉",
  "_resume_prefix": "वापसी पर स्वागत है! आइए आपकी लिस्टिंग जारी रखें।",
  "_revision_prefix": "आइए इसे अपडेट करें। ",
  "_revision_select": "कौन से फ़ील्ड ठीक करने हैं उन्हें चुनें:",
  "location_set_success": "स्थान {{place}} पर सेट कर दिया गया है।",
  "floor_number_pg": "आपका PG इमारत की किस मंजिल पर है?",
  "pg_sharing_details_rent": "{{sharingLabel}} रूम के लिए किराया और कमरों की संख्या बताएं।",
  "pg_sharing_details_sell": "{{sharingLabel}} शेयरिंग के लिए कितने कमरे उपलब्ध हैं?",
  "locality_tier": "यह इलाका किस श्रेणी (टियर) में आता है?",
  "sale_type": "क्या यह नई संपत्ति है या पुनर्विक्रय (रीसेल)?",
  "ownership": "इस संपत्ति का स्वामित्व/शीर्षक प्रकार क्या है?",
  "rera": "क्या यह संपत्ति RERA पंजीकृत/अनुमोदित है?"
}
